import { Ratchet } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { isNil } from 'lodash';

export const getThresholdFieldName = (threshold: number, suffix = '') => {
    const thresholdPercent = (threshold * 100).toFixed(0);
    return `threshold${thresholdPercent}${suffix}`;
};

export const getThresholdDisplayName = (ratchet: Ratchet, suffix = '') => {
    if (isNil(ratchet.threshold) || isNil(ratchet.thresholdOperator)) return '';
    const thresholdPercent = (ratchet.threshold * 100).toFixed(0);
    if (ratchet.thresholdOperator === '><') {
        return `> -${thresholdPercent}% and < ${thresholdPercent}%`;
    }
    return `${ratchet.thresholdOperator} ${thresholdPercent}%${suffix}`;
};
